import type React from 'react';

import Grid from '@mui/material/Grid';

import { useStyles } from 'components/lists/styles';

export interface AvoidanceListItemInterface {
  key: string;
  element: React.ReactNode;
}

interface AvoidanceRulesListProps {
  listItems: AvoidanceListItemInterface[];
}

const AvoidanceRulesList: React.FC<React.PropsWithChildren<AvoidanceRulesListProps>> = ({ listItems }) => {
  const { classes } = useStyles();
  return (
    <Grid container className={classes.listWrapper} direction="row" spacing={2}>
      {listItems.map((item) => (
        <Grid key={item.key} item sm={6} xs={12}>
          {item.element}
        </Grid>
      ))}
    </Grid>
  );
};

export default AvoidanceRulesList;
